// import earringsBanner from '@/assets/pc/earrings/banner.jpg'

export const productList = [
  {
    img: require('@/assets/pc/earrings/1-1.jpg'),
    path: '/ProductDetail',
    text: 'PACIFIC EARRINGS',
    price: 1000,
    date: '2021/09/01',
    soldOut: 200,
    color: 'blue',
    material: 'kyanite',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 0
  },
  {
    img: require('@/assets/pc/earrings/1-2.jpg'),
    path: '',
    text: 'DROP EARRINGS',
    price: 2060,
    date: '2021/09/20',
    soldOut: 100,
    color: 'blue',
    material: 'kyanite',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 1
  },
  {
    img: require('@/assets/pc/earrings/1-3.jpg'),
    path: '',
    text: 'TURQUOISE MAHSA EARRINGS',
    price: 1500,
    date: '2021/10/03',
    soldOut: 109,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 2
  },
  {
    img: require('@/assets/pc/earrings/1-4.jpg'),
    path: '',
    text: 'TURQUOISE ZEEB LONG EARRINGS',
    price: 1800,
    date: '2021/11/20',
    soldOut: 50,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 3
  },
  {
    img: require('@/assets/pc/earrings/2-1.jpg'),
    path: '',
    text: 'MYANMAR STARFISH STUDS',
    price: 1030,
    date: '2021/10/15',
    soldOut: 67,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 4
  },
  {
    img: require('@/assets/pc/earrings/2-2.jpg'),
    path: '',
    text: 'MYANMAR SCALLOP STUDS',
    price: 2030,
    date: '2021/11/03',
    soldOut: 109,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 5
  },
  {
    img: require('@/assets/pc/earrings/2-3.jpg'),
    path: '',
    text: 'TURQUOISE SHELL EARRINGS',
    price: 2070,
    date: '2021/09/01',
    soldOut: 78,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 6
  },
  {
    img: require('@/assets/pc/earrings/2-4.jpg'),
    path: '',
    text: 'TURQUOISE SNAIL EARRINGS',
    price: 1880,
    date: '2021/11/22',
    soldOut: 19,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 7
  },
  {
    img: require('@/assets/pc/earrings/3-1.jpg'),
    path: '',
    text: 'ZEEB SHORT EARRINGS',
    price: 580,
    date: '2021/08/03',
    soldOut: 267,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 8
  },
  {
    img: require('@/assets/pc/earrings/3-2.jpg'),
    path: '',
    text: 'AGATE TRIPLE EARRINGS',
    price: 990,
    date: '2021/09/30',
    soldOut: 136,
    color: 'grey',
    material: 'kyanite',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 9
  },
  {
    img: require('@/assets/pc/earrings/3-3.jpg'),
    path: '',
    text: 'TURQUOISE STUD EARRINGS',
    price: 1070,
    date: '2021/10/17',
    soldOut: 34,
    color: 'blue',
    material: 'turquoise',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 10
  },
  {
    img: require('@/assets/pc/earrings/3-4.jpg'),
    path: '',
    text: 'MOONSTONE STUD EARRINGS',
    price: 1800,
    date: '2021/10/06',
    soldOut: 112,
    color: 'white',
    material: 'opal',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 11
  },
  {
    img: require('@/assets/pc/earrings/4-1.jpg'),
    path: '',
    text: 'STUD EARRINGS',
    price: 1390,
    date: '2021/08/28',
    soldOut: 45,
    color: 'yellow',
    material: 'gold',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 12
  },
  {
    img: require('@/assets/pc/earrings/4-2.jpg'),
    path: '',
    text: 'STUD RUBY EARRINGS',
    price: 4300,
    date: '2021/09/20',
    soldOut: 89,
    color: 'red',
    material: 'ruby',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 13
  },
  {
    img: require('@/assets/pc/earrings/4-3.jpg'),
    path: '',
    text: 'STUD EARRINGS',
    price: 2100,
    date: '2021/09/15',
    soldOut: 190,
    color: 'grey',
    material: 'kyanite',
    favoriteStatus: 0,
    cartStatus: 0,
    id: 14
  }
]
